import { useContext, useState } from "react";
import CartItems from "../Components/CartIems";
import PurchaseForm from "../Components/forms/PurchaseForm";
import { CartContext } from "../context/CartContext";
import purchaseService from "../services/purchaseService";
import SpinnerOverlay from "../Components/SpinnerOverlay";
import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import CheckoutQR from "../Components/CheckoutQR";
import { getFirstErrorMessage } from "../helpers/getErrorsMessages";
import PromotionCodeBox from "../Components/PromotionCodeBox";

const Cart = () => {
    const [userData, setUserData] = useState({});
    const { cartItems, total, cleanCart } =
        useContext(CartContext);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const [activeModal, setActiveModal] = useState({
        isVisible: false,
        qr_code: null,
        url: null,
    });
    const [termsyconditions, setTermsyconditions] = useState(false);

    const [promoData, setPromoData] = useState(null);
    const displayedTotal = promoData?.finalTotal ?? total;



    const handleSubmit = async () => {
        try {
            const { email, dni, phone, confirmEmail, name } = userData;
            setError("");
            if (!email || !name || !confirmEmail || !dni || !phone) {
                setError("Campos sin completar");
                return;
            }
            if (userData.email !== userData.confirmEmail) {
                setError("Los emails no coinciden");
                return;
            }
            if (
                userData.dni.length < 7 ||
                isNaN(userData.dni) ||
                !/^\d+$/.test(userData.dni)
            ) {
                setError("DNI invalido");
                return;
            }
            if (
                userData.phone.length < 8 ||
                isNaN(userData.phone) ||
                !/^\d+$/.test(userData.phone)
            ) {
                setError("Telefono invalido");
                return;
            }
            if (cartItems.length === 0) {
                setError("Carrito vacio");
                return;
            }
            if (!termsyconditions) {
                setError("Debe aceptar los terminos y condiciones");
                return;
            }
            setLoading(true);

            const response = await purchaseService.getPreference({
                userData,
                cartItems,
                promotionCode: promoData?.promotionCode,
            });
            await login(response.data.token, {
                ...userData,
                id: response.data.userId,
            });
            setLoading(false);
            if (!response.data.free) {
                setActiveModal({
                    isVisible: true,
                    qr_code: response.data.qr_code,
                    url: response.data.url,
                });
            } else {
                window.alert("Compra realizada con Exito");
                cleanCart();
                navigate("/tickets");
            }
        } catch (error) {
            setLoading(false);
            const data = error.response.data;
            console.log(data);
            window.alert(
                data.error ||
                getFirstErrorMessage(data.errors) ||
                "Error al realizar la compra"
            );
        }
    };

    return (
        <div className="mx-2 min-h-screen mb-32">
            <SpinnerOverlay isLoading={loading} />
            <CartItems />
            <PurchaseForm
                setUserData={setUserData}
                setTermsyconditions={setTermsyconditions}
                termsyconditions={termsyconditions}
            />
            <PromotionCodeBox
                cartItems={cartItems}
                onApplied={setPromoData}
            />
            {error && (
                <p className="text-red-600 text-center py-4 font-sans">
                    {error}
                </p>
            )}
            <div className="max-w-lg flex gap-2 mx-auto p-4 bg-zinc-900 mt-6 rounded-sm">
                <p className="text-lg">
                    Total:
                    {promoData && (
                        <span className="line-through ml-2 text-zinc-400">
                            ${total}
                        </span>
                    )}
                </p>

                <p className={`text-lg ${promoData ? "text-green-500" : ""}`}>
                    ${displayedTotal}
                </p>
            </div>

            <CheckoutQR
                isVisible={activeModal.isVisible}
                qr_code={activeModal.qr_code}
                url={activeModal.url}
                activeModal={activeModal}
                setActiveModal={setActiveModal}
                cleanCart={cleanCart}
                navigate={navigate}
            />
            <div className="max-w-lg m-auto mt-5">
                <button
                    disabled={loading}
                    onClick={handleSubmit}
                    className="bg-yellow-cdg hover:bg-yellow-600 text-black py-3 px-4 rounded-lg w-full disabled:opacity-50"
                >
                    Comprar
                </button>

            </div>
        </div>
    );
};

export default Cart;
